import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUtility, Stack, Text } from '@hub-la/design-system';
import { alpha } from '@mui/system';
import moment from 'moment';
import 'moment/locale/pt-br';

const EventDate = ({
  date
}) => {
  const {
    palette
  } = useUtility();
  const day = date.getDate();
  const month = moment(date).locale('pt-br').format('MMM').toUpperCase();
  return jsxs(Stack, Object.assign({
    position: "absolute",
    justifyContent: "center",
    borderRadius: 1,
    p: 1,
    left: 8,
    top: 8,
    width: "100%",
    height: "100%",
    maxHeight: 40,
    maxWidth: 40,
    bgcolor: alpha(palette('background'), 0.5),
    style: {
      backdropFilter: 'blur(5px)'
    },
    "data-testid": "event-date"
  }, {
    children: [jsx(Text, Object.assign({
      variant: "body1",
      fontWeight: 700,
      color: "onSurface",
      textAlign: "center",
      width: 32,
      lineHeight: "16px"
    }, {
      children: day
    })), jsx(Text, Object.assign({
      variant: "body1",
      color: "onSurfaceVariant",
      textAlign: "center",
      width: 32,
      lineHeight: "10px",
      fontSize: 10
    }, {
      children: month
    }))]
  }));
};

export { EventDate as default };
